import { v4 as uuidv4 } from 'uuid'
import { WorkSearch } from '@App/stores/search/models/work-search'
import { SelectOptionHide } from '@App/stores/search/models/select-option-hide'

export const MATCHED_RECORDING_NON_EXPORTABLE_KEYS = [
    'matchedRecordingTitles',
    'matchedRecordingIsrcs',
] as const satisfies ReadonlyArray<keyof WorkSearch>

const matchedRecordingSearchOptionLabels: Record<(typeof MATCHED_RECORDING_NON_EXPORTABLE_KEYS)[number], string> = {
    matchedRecordingTitles: 'Recording Title',
    matchedRecordingIsrcs: 'ISRC',
}

export const createMatchedRecordingSearchOptions = (): Array<SelectOptionHide<WorkSearch>> =>
    MATCHED_RECORDING_NON_EXPORTABLE_KEYS.map((value) => ({
        id: uuidv4(),
        value,
        label: matchedRecordingSearchOptionLabels[value],
    }))
